<template>
  <div class="main-layout">

    <!-- ================= SIDEBAR ================= -->
    <aside :class="['sidebar', sidebarOpen ? 'open' : '']">

      <!-- LOGO -->
      <div class="sidebar-header">

        <div class="shop-logo">
          <img src="@/assets/logo_baraka.jpeg" alt="MediStock" />
        </div>

        <div class="shop-info">
          <h4>{{ nomBoutique || "MEDISTOCK" }}</h4>
          <span>Gestion des matériels médicaux</span>
        </div>

      </div>

      <!-- MENU -->
      <nav class="menu">

        <!-- DASHBOARD -->
        <router-link
          to="/"
          v-if="$store.getters.hasPermission('DASH_VIEW')"
          class="menu-link"
          exact-active-class="active-link"
          @click="navigateAndClose('/')"
        >
          <i class="bi bi-grid-1x2-fill"></i>
          <span>Tableau de bord</span>
        </router-link>

        <!-- CLIENTS -->
        <router-link hidden
          to="/clients"
          class="menu-link"
          exact-active-class="active-link"
          @click="navigateAndClose('/clients')"
        >
          <i class="bi bi-people-fill"></i>
          <span>Patients</span>
        </router-link>

        <!-- PRODUITS -->
        <router-link
          v-if="$store.getters.hasPermission('PRODUIT_LIST')"
          to="/produits"
          class="menu-link"
          exact-active-class="active-link"
          @click="navigateAndClose('/produits')"
        >
          <i class="bi bi-capsule"></i>
          <span>Articles médicaux</span>
        </router-link>

        <!-- COMMANDES -->
        <router-link hidden
          to="/reparations"
          class="menu-link"
          exact-active-class="active-link"
          @click="navigateAndClose('/reparations')"
        >
          <i class="bi bi-cart-check-fill"></i>
          <span>Commandes</span>
        </router-link>

        <!-- RENDEZ-VOUS -->
        <router-link hidden
          to="/rendez-vous"
          class="menu-link"
          exact-active-class="active-link"
          @click="navigateAndClose('/rendez-vous')"
        >
          <i class="bi bi-calendar-check-fill"></i>
          <span>Livraisons</span>
        </router-link>

        <!-- ================= CONFIGURATION ================= -->
        <div class="menu-group"
          v-if="
            $store.getters.hasPermission('CAT_LIST') ||
            $store.getters.hasPermission('PAYMENT_METHOD')
          "
        >

          <div
            class="menu-link menu-collapse"
            @click="toggleCollapse('config')"
          >

            <div class="menu-content">
              <i class="bi bi-sliders"></i>
              <span>Configuration</span>
            </div>

            <i
              class="bi arrow"
              :class="openedCollapse === 'config'
              ? 'bi-chevron-up'
              : 'bi-chevron-down'"
            ></i>

          </div>

          <div
            v-show="openedCollapse === 'config'"
            class="submenu"
          >

            <router-link
              v-if="$store.getters.hasPermission('PAYMENT_METHOD')"
              to="/moyen_paiements"
              class="submenu-link"
              @click="navigateAndClose('/moyen_paiements')"
            >
              Modes de dispensation
            </router-link>

            <router-link
              v-if="$store.getters.hasPermission('CAT_LIST')"
              to="/categories-produits"
              class="submenu-link"
              @click="navigateAndClose('/categories-produits')"
            >
              Catégories médicales
            </router-link>

          </div>

        </div>

        <!-- ================= STOCK ================= -->
        <div class="menu-group"
          v-if="
            $store.getters.hasPermission('APPROV_LIST') ||
            $store.getters.hasPermission('VENTE_LIST') ||
            $store.getters.hasPermission('LOT_LIST')
          "
        >

          <div
            class="menu-link menu-collapse"
            @click="toggleCollapse('stock')"
          >

            <div class="menu-content">
              <i class="bi bi-box-seam-fill"></i>
              <span>Stock & mouvements</span>
            </div>

            <i
              class="bi arrow"
              :class="openedCollapse === 'stock'
              ? 'bi-chevron-up'
              : 'bi-chevron-down'"
            ></i>

          </div>

          <div
            v-show="openedCollapse === 'stock'"
            class="submenu"
          >

            <router-link
              v-if="$store.getters.hasPermission('APPROV_LIST')"
              to="/approvs"
              class="submenu-link"
              @click="navigateAndClose('/approvs')"
            >
              Approvisionnements
            </router-link>

            <router-link
              v-if="$store.getters.hasPermission('VENTE_LIST')"
              to="/ventes"
              class="submenu-link"
              @click="navigateAndClose('/ventes')"
            >
              Sorties / Dispensation
            </router-link>

            <router-link
              v-if="$store.getters.hasPermission('LOT_LIST')"
              to="/stocks-lots"
              class="submenu-link"
              @click="navigateAndClose('/stocks-lots')"
            >
              Stock par lot
            </router-link>

          </div>

        </div>

        <!-- ================= FINANCE ================= -->
        <div class="menu-group" hidden>

          <div
            class="menu-link menu-collapse"
            @click="toggleCollapse('finance')"
          >

            <div class="menu-content">
              <i class="bi bi-cash-stack"></i>
              <span>Finances</span>
            </div>

            <i
              class="bi arrow"
              :class="openedCollapse === 'finance'
              ? 'bi-chevron-up'
              : 'bi-chevron-down'"
            ></i>

          </div>

          <div
            v-show="openedCollapse === 'finance'"
            class="submenu"
          >

            <router-link
              to="/factures"
              class="submenu-link"
              @click="navigateAndClose('/factures')"
            >
              Factures
            </router-link>

            <router-link
              to="/paiements"
              class="submenu-link"
              @click="navigateAndClose('/paiements')"
            >
              Paiements
            </router-link>

            <router-link
              to="/depenses"
              class="submenu-link"
              @click="navigateAndClose('/depenses')"
            >
              Dépenses
            </router-link>

          </div>

        </div>

        <!-- ================= ADMIN ================= -->
        <div class="menu-group"
          v-if="
            $store.getters.hasPermission('USER_LIST') ||
            $store.getters.hasPermission('ROLE_LIST')
          "
        >

          <div
            class="menu-link menu-collapse"
            @click="toggleCollapse('admin')"
          >

            <div class="menu-content">
              <i class="bi bi-shield-lock-fill"></i>
              <span>Administration</span>
            </div>

            <i
              class="bi arrow"
              :class="openedCollapse === 'admin'
              ? 'bi-chevron-up'
              : 'bi-chevron-down'"
            ></i>

          </div>

          <div
            v-show="openedCollapse === 'admin'"
            class="submenu"
          >

            <router-link
              v-if="$store.getters.hasPermission('USER_LIST')"
              to="/utilisateurs"
              class="submenu-link"
              @click="navigateAndClose('/utilisateurs')"
            >
              Utilisateurs
            </router-link>

            <router-link
              v-if="$store.getters.hasPermission('ROLE_LIST')"
              to="/roles"
              class="submenu-link"
              @click="navigateAndClose('/roles')"
            >
              Rôles
            </router-link>

            <router-link
              v-if="$store.getters.hasPermission('SUPERADMIN')"
              to="/configurations"
              class="submenu-link"
              @click="navigateAndClose('/configurations')"
            >
              Paramètres
            </router-link>

          </div>

        </div>

      </nav>

    </aside>

    <!-- OVERLAY -->
    <div
      v-if="sidebarOpen"
      class="mobile-overlay"
      @click="toggleSidebar"
    ></div>

    <!-- ================= CONTENT ================= -->
    <section class="content-area">

      <!-- TOPBAR -->
      <header class="topbar">

        <button class="menu-btn" @click="toggleSidebar">
          <i class="bi bi-list"></i>
        </button>

        <div class="topbar-title">
          <h5>Tableau de pilotage </h5>
          <span>Gestion des matériels médicaux</span>
        </div>

        <!-- USER -->
        <div class="user-box dropdown">

          <button
            class="user-btn dropdown-toggle"
            data-bs-toggle="dropdown"
          >

            <img :src="userAvatar" class="user-avatar" />

            <div class="user-text">
              <strong>
                {{ currentUser?.nom }}
                {{ currentUser?.prenom }}
              </strong>

              <small>Utilisateur</small>
            </div>

          </button>

          <ul class="dropdown-menu dropdown-menu-end">

            <li>
              <router-link class="dropdown-item" to="/compte">
                Mon compte
              </router-link>
            </li>

            <li>
              <hr class="dropdown-divider">
            </li>

            <li>
              <a
                class="dropdown-item text-danger"
                href="#"
                @click.prevent="logout"
              >
                Déconnexion
              </a>
            </li>

          </ul>

        </div>

      </header>

      <!-- MAIN -->
      <main class="main-content">
        <router-view />
      </main>

    </section>

  </div>
</template>

<script>
import api from "@/api";

export default {
  name: "MainLayout",

  data() {
    return {
      sidebarOpen: false,
      openedCollapse: null,
      nomBoutique: null
    };
  },

  computed: {
    currentUser() {
      return this.$store.getters.user;
    },

    userAvatar() {
      return this.currentUser?.photo ||
        "https://cdn-icons-png.flaticon.com/512/3135/3135715.png";
    }
  },

  async created() {
    await this.fetchBoutiqueConfig();
  },

  methods: {

    async fetchBoutiqueConfig() {
      try {
        const res = await api.getItems("configurations/entete");
        this.nomBoutique = res.data.nom;
      } catch {
        this.nomBoutique = "MEDISTOCK";
      }
    },

    toggleSidebar() {
      this.sidebarOpen = !this.sidebarOpen;
    },

    toggleCollapse(name) {
      this.openedCollapse =
        this.openedCollapse === name ? null : name;
    },

    navigateAndClose(link) {
      if (window.innerWidth < 768) {
        this.sidebarOpen = false;
        this.openedCollapse = null;

        setTimeout(() => {
          this.$router.push(link);
        }, 150);
      } else {
        this.$router.push(link);
      }
    },

    logout() {
      this.$store.dispatch("logout");
      this.$router.push("/login");
    }
  }
};
</script>
<style scoped>

/* ================= GLOBAL ================= */
.main-layout {
  display: flex;
  min-height: 100vh;
  background: #f4f7fb;
  font-family: "Inter", sans-serif;
  overflow-x: hidden;
}

/* ================= SIDEBAR ================= */
.sidebar {
  width: 290px;
  position: fixed;
  inset: 0 auto 0 0;
  padding: 20px;

  background: linear-gradient(
    180deg,
    #071a2e 0%,
    #0f4c81 100%
  );

  overflow-y: auto;
  transition: transform 0.3s ease;
  z-index: 1000;

  box-shadow: 0 0 30px rgba(0,0,0,0.25);
}

/* ================= HEADER ================= */
.sidebar-header {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 35px;
}

.shop-logo {
  width: 60px;
  height: 60px;
  border-radius: 16px;
  background: white;

  display: flex;
  align-items: center;
  justify-content: center;

  box-shadow: 0 10px 25px rgba(0,0,0,0.15);
}

.shop-logo img {
  width: 45px;
  height: 45px;
  object-fit: contain;
}

.shop-info h4 {
  color: white;
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
}

.shop-info span {
  color: rgba(255,255,255,0.75);
  font-size: 0.75rem;
}

/* ================= MENU ================= */
.menu {
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.menu-link {
  display: flex;
  align-items: center;
  gap: 12px;

  padding: 13px 14px;

  border-radius: 14px;

  color: rgba(255,255,255,0.85);
  text-decoration: none;

  transition: 0.25s ease;
}

.menu-link i {
  font-size: 1rem;
}

.menu-link:hover {
  background: rgba(255,255,255,0.08);
  color: #ffffff;
  transform: translateX(3px);
}

/* ACTIVE */
.active-link {
  background: linear-gradient(
    135deg,
    #00c853,
    #00acc1
  );

  color: white;
  box-shadow: 0 8px 18px rgba(0, 200, 83, 0.25);
}

/* ================= GROUP ================= */
.menu-group {
  display: flex;
  flex-direction: column;
}

.menu-collapse {
  justify-content: space-between;
  cursor: pointer;
}

.menu-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.arrow {
  font-size: 0.85rem;
  color: rgba(255,255,255,0.8);
}

/* ================= SUBMENU ================= */
.submenu {
  margin-left: 16px;
  margin-top: 6px;
  padding-left: 12px;

  border-left: 1px solid rgba(255,255,255,0.12);

  display: flex;
  flex-direction: column;
  gap: 4px;
}

.submenu-link {
  padding: 9px 12px;
  border-radius: 10px;

  color: rgba(255,255,255,0.7);
  text-decoration: none;

  font-size: 0.92rem;
  transition: 0.2s ease;
}

.submenu-link:hover {
  background: rgba(255,255,255,0.06);
  color: white;
}

/* ================= CONTENT ================= */
.content-area {
  margin-left: 290px;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

/* ================= TOPBAR ================= */
.topbar {
  height: 75px;
  background: white;

  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 0 18px;

  border-bottom: 1px solid #e5e7eb;

  position: sticky;
  top: 0;
  z-index: 50;
}

.topbar-title h5 {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: #0f172a;
}

.topbar-title span {
  color: #64748b;
  font-size: 0.82rem;
}

/* ================= USER ================= */
.user-btn {
  border: none;
  background: white;

  display: flex;
  align-items: center;
  gap: 10px;

  padding: 8px 12px;

  border-radius: 14px;

  transition: 0.2s ease;
}

.user-btn:hover {
  background: #f1f5f9;
}

.user-avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  object-fit: cover;
}

.user-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.user-text small {
  color: #64748b;
}

/* ================= MENU BTN ================= */
.menu-btn {
  display: none;
  border: none;
  background: #f1f5f9;

  width: 42px;
  height: 42px;

  border-radius: 12px;

  font-size: 1.2rem;
}

/* ================= MAIN ================= */
.main-content {
  flex: 1;
  padding: 20px;
}

/* ================= OVERLAY ================= */
.mobile-overlay {
  position: fixed;
  inset: 0;

  background: rgba(0,0,0,0.65);
  backdrop-filter: blur(3px);

  z-index: 999;
}

/* ================= RESPONSIVE ================= */
@media (max-width: 768px) {

  .sidebar {
    transform: translateX(-100%);
  }

  .sidebar.open {
    transform: translateX(0);
  }

  .content-area {
    margin-left: 0;
    width: 100%;
  }

  .menu-btn {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .topbar-title {
    display: none;
  }

  .user-text {
    display: none;
  }

  .main-content {
    padding: 14px;
  }
}

/* ================= SMALL MOBILE ================= */
@media (max-width: 480px) {

  .sidebar {
    width: 280px;
  }

  .main-content {
    padding: 10px;
  }
}

</style>